import { Link } from 'react-router-dom';

import { Icon } from '@/new/components/icon';

export function KimErrorState() {
  return (
    <div className="pointer-events-auto flex w-full gap-2.5 rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-red-600">
      <Icon className="lucide--triangle-alert mt-0.75" />
      <span>
        Something went wrong when trying to generate a response. Please try again in a{' '}
        <Link
          to="../"
          className="inline-flex items-center gap-1 underline! decoration-red-300! underline-offset-4 duration-150 hover:text-red-500"
        >
          new thread
          <Icon className="lucide--arrow-up-right" />
        </Link>
      </span>
    </div>
  );
}
